import * as React from "react";

import { DailyEventView } from "./DailyEventView/DailyEventView";
import { DailyListEventView } from "./DailyListEventView/DailyListEventView";
import { MonthlyEventView } from "./MonthlyEventView/MonthlyEventView";
import { MonthlyEventViewMobile } from "./MonthlyEventViewMobile/MonthlyEventViewMobile";
import { MonthlyListEventView } from "./MonthlyListEventView/MonthlyListEventView";
import { WeeklyEventView } from "./WeeklyEventView/WeeklyEventView";

import { MONTHLY_MOBILE_WIDTH } from "../../classes/const";
import { IEvent } from "../../classes/event";
import { IText } from "../../classes/text";

export interface IEventViewProps {
  calendarId: number;
  contextId: number;
  currentDate: Date;
  events: IEvent[];
  firstDayOfWeek: string;
  localToDate: Date;
  localFromDate: Date;
  numAjaxCallsInProgress: number;
  objectId: number;
  pageId: number;
  parentId: number;
  portalId: number;
  portletInstanceId: number;
  searchCategory: string;
  searchFilter: string;
  searchText: string;
  selectedDate: Date;
  text: IText;
  todaysDate: Date;
  userDateFormat: string;
  viewMode: string;
  width: number;
  onSetCurrentDate: (event: any) => any;
  onSetEventId: (eventId: number) => any;
  onSetiCalStartDate: (iCalStartDate: Date) => any;
  onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
  onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
  onSetSelectedDate: (event: any) => any;
  onSetViewMode: (event: any) => any;
  onSetEventScreenMode: (eventScreenMode: string) => any;
  onStartAjaxCall: (event: any) => any;
}

export const EventView = (props: IEventViewProps) => {
  switch (props.viewMode) {
    case "DAILYLIST": {
      return <DailyListEventView {...props} />;
    }
    case "DAILY": {
      return <DailyEventView {...props} />;
    }
    case "WEEKLY": {
      return <WeeklyEventView {...props} />;
    }
    case "MONTHLY": {
      if (props.width > MONTHLY_MOBILE_WIDTH) {
        return <MonthlyEventView {...props} />;
      } else {
        return <MonthlyEventViewMobile {...props} />;
      }
    }
    case "MONTHLYLIST": {
      return <MonthlyListEventView {...props} />;
    }
    default: {
      return null;
    }
  }
};
